


















































import Vue from "vue";
import { clearAuth } from "./helpers";
import store from "./store";
import axios from "axios";

export default Vue.extend({
	props: ['panelMinimized'],

	data() {
		return {
			isOpen: true,
         languages: ['fi'],
         selectedLanguage: '',
         langCodes: 
         [
				{ language: "Suomi", code: "fi" },
				{ language: "Svenska", code: "se" },
				{ language: "English", code: "en" }
         ]         
		}
	},

	methods: {
		signOut() {
			let org = this.$store.state.org;
			this.$router.push({ name: 'Home', params: { org: org } });
			clearAuth(this.$store);
			alert('Signed out');
		},
		toggleOpen() {
			this.$emit("togglePanel")
		},
		goHome() {
			this.$router.push({name: 'Itsepalvelu', params: { org: this.$store.state.org, lang: this.$store.state.lang } })
		},
		enterAbilitatorPage() {
			this.$router.push({name: 'Kykyviisari', params: { org: this.$store.state.org, lang: this.$store.state.lang } })
		},
		enterSkillsPage() {
			this.$router.push({name: 'Skills', params: { org: this.$store.state.org, lang: this.$store.state.lang } })
		},
		enterKeywordsAndJobsPage() {
			this.$router.push({name: 'KeywordsAndJobs', params: { org: this.$store.state.org, lang: this.$store.state.lang } })
		},
		toggleMobileMenu() {
			store.commit("setMobileMenu", !this.showMobileMenu)
		},
      languagesInUse(){
         axios.get(`auth/languages/${this.$store.state.org}`, {'headers': {"org": this.$store.state.org}}).then(r => {
				this.languages = r.data;
            if(r.data=="" || r.data==undefined || r.data == null){
               this.languages = ["fi"];
            }
			}).catch(ex => {
				if(ex.error) {
					this.languages = ["fi"];
				}
			})
         this.selectedLanguage = this.$store.state.lang;
      },
      changeLanguage(){
         let payload = {
            org: this.$store.state.org,
            lang: this.selectedLanguage
         };
         this.$i18n.locale = this.selectedLanguage;
         this.$store.commit("setOrgLang", payload);            
      },
		getLanguageName(langCode: string){
			var language = this.langCodes.filter((qObj)=>{return qObj.code === langCode;}).pop();
			if(language !== undefined){
				return language.language;
			} else {
				return "unknown"
			}
		}

	},
   created(){
      this.languagesInUse();
   },
	computed: {
		isMobile() :boolean {
			// const vpWidth = window.document.body.clientWidth;
			// if (vpWidth < 576) {
			// 	return true
			// }
			// else return false
			return store.state.isMobile;
		},
		showMobileMenu() {
			return store.state.showMobileMenu
		}
	}
});
